import React, { useState, useEffect } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { listStoreRecords } from 'graphql/queries';
import StoreRecordCreateForm from 'ui-components/StoreRecordCreateForm'
import StoreRecordUpdateForm from 'ui-components/StoreRecordUpdateForm'
// import { StoreRecordCreateForm, StoreRecordUpdateForm } from "ui-components";
import DashboardLayout from 'layouts/DashboardLayout'
import DashboardNavbar from 'components/RDNavbars/DashboardNavbar';

export default function StoreRecordPage() {
  const [mode, setMode] = useState(null); // 'create' | 'update'
  const [stores, setStores] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState(null);

  // Fetch stores only in 'update' mode
  useEffect(() => {
    if (mode === 'update') {
      async function fetchStores() {
        try {
          const res = await API.graphql(graphqlOperation(listStoreRecords));
          setStores(res.data.listStoreRecords.items);
        } catch (err) {
          console.error('Error fetching stores:', err);
        }
      }
      fetchStores();
    }
  }, [mode]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div>
        <h2>Store Record Manager</h2>

        {/* Mode Selection */}
        <div style={{ marginBottom: '1rem' }}>
          <button onClick={() => setMode('create')}>Create StoreRecord</button>
          <button onClick={() => setMode('update')}>Update StoreRecord</button>
        </div>

        {/* Create Form */}
        {mode === 'create' && (
          <div>
            <h3>Create New Store</h3>
            <StoreRecordCreateForm
              onSuccess={(fields) => console.log('Created:', fields)}
              onError={(fields, msg) => console.error('Create failed:', msg, fields)}
            />
          </div>
        )}

        {/* Update Flow */}
        {mode === 'update' && (
          <div>
            <h3>Select Store to Update</h3>
            <select
              onChange={(e) => setSelectedStoreId(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>
                -- Select a store --
              </option>
              {stores.map((store) => (
                <option key={store.id} value={store.id}>
                  {store.storeName}
                </option>
              ))}
            </select>

            {selectedStoreId && (
              <div style={{ marginTop: '2rem' }}>
                <h3>Editing Store</h3>
                <StoreRecordUpdateForm id={selectedStoreId} />
              </div>
            )}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}